import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createSpecialty, editSpecialty, showSpecialty } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { SpecialtyProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Specialty() {
  return (
    <SpecialtyProvider>
      <Switch>
        <Route
          exact
          path={createSpecialty.spec}
          render={(props) => (
            <>
              <Can I="new" a="Specialties">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Specialties">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editSpecialty.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Specialties">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Specialties">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showSpecialty.spec}
          render={(props) => (
            <>
              <Can I="show" a="Specialties">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Specialties">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Specialties">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Specialties">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </SpecialtyProvider>
  );
}
export default Specialty;
